export default "__VITE_ASSET__D26Je9Nx__"